module.exports = __webpack_public_path__ + "img/rent0.c392b300.jpg";